module.exports = __webpack_public_path__ + "static/Muli-Italic-e7d9392f0a15b9e6029cfcd68a4a427e.woff";